import { Box } from '@mui/material';

import Button from '@/components/Buttons/Button';

const StepButtons = ({
  activeStep,
  onNextClick,
  onBackClick,
  nextDisabled
}: {
  activeStep: number;
  onBackClick: () => void | Promise<void>;
  onNextClick: () => void | Promise<void>;
  nextDisabled?: boolean;
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      {activeStep !== 0 && (
        <Button
          fullWidth
          disabled={activeStep === 0}
          sx={{
            '&.MuiButton-outlined': {
              color: 'primary.main',
              borderColor: 'primary.main'
            },
            mr: 1
          }}
          variant='outlined'
          onClick={() => {
            void onBackClick();
          }}
        >
          Back
        </Button>
      )}
      <Button
        fullWidth
        disabled={nextDisabled}
        sx={{
          color: 'background.default'
        }}
        variant='contained'
        onClick={() => {
          void onNextClick();
        }}
      >
        Next
      </Button>
    </Box>
  );
};
export default StepButtons;
